module.exports = "<list-view\n  paginate-event=\"$ctrl.paginateEvent\"\n  title=\"Invoice Item Types Uploads\"\n  resource=\"InvoiceItemType\"\n  resource-method=\"getFiles\"\n  resource-params=\"$ctrl.resourceParams\"\n  transformer=\"BulkInvoiceItemTypesUploadsTransforms\"\n  item-state=\"bulkinvoiceitemtypesuploaddetails\"\n></list-view>\n\n<main-footer></main-footer>\n<main-sidenav sections=\"$ctrl.sections\"></main-sidenav>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/bulkInvoiceItemTypesUploads/bulkInvoiceItemTypesUploads.html
// module id = 2211
// module chunks = 0